import styled, { css } from 'styled-components';

export const Container = styled.div`
    position: absolute;
    display: ${props => props.open ? 'flex' : 'none'};
    flex-direction: column;
    width: 315px;
    height: 121px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 10000;
    background: #8DB0BF;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    box-sizing: border-box;
    padding: 10px;

    h1 {
        margin: 0;
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        color: #FFFFFF;
    }

    span {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 300;
        font-size: 14px;
        line-height: 15px;
        color: #FFFFFF;
    }

    div {
        position: absolute;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 90%;
        bottom: 10px;
        right: 50%;
        transform: translate(50%);
    }
`;

export const Button = styled.button`
    width: 130px;
    height: 45px;
    left: 18px;
    top: 61px;
    border: none;
    background: ${props => props.backgroundColor ? props.backgroundColor : ''};
    border-radius: 5px;

    font-family: 'Poppins';
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    color: #FFFFFF;
    cursor: pointer;
`
